module.exports = __webpack_public_path__ + "static/media/dtre.c02cca70.jpg";